<template>
  <div>
    <!-- 筛选 -->
    <my-search
      timeScreen
      :order="1"
      :inputArr="inputArr"
      :searchParams="searchParams"
      :[dynamicData]="2"
      @searchEvent="searchEvent"
      @allDel="allDel"
      @allExport="allExport"
      @allImportTemplate="allImportTemplate"
    />

    <!-- 列表  isSelection-->
    <my-table
      :loading="loading"
      :tableData="tableData"
      :tableHeader="tableHeader"
      :pageParams="pageParams"
      @click.native="testNative"
      @handleSelectionChange="handleSelectionChange"
    />

    <!-- 分页组件 -->
    <my-pagination :childMsg="pageParams" @callFather="callFather" />
  </div>
</template>

<script>
import _exportMethods from "@/utils/excel";
import mixins from "@/mixins/common";
import {
  collectionList,
  delCollection,
  allDelCollection,
} from "@/network/other/collection";
export default {
  mixins: [mixins],
  provide() {
    return {
      importType: "collection",
      initData: this.getInitData,
    };
  },
  watch: {
    tableData: {
      handler(val) {
        // console.log(val);
      },
      immediate: false,
      deep: false,
    },
  },
  data() {
    return {
      /**
       * 当前头部数据列
       * 不需要响应式的数据可以进行冻结，Vue实例不会对数据再做数据劫持(getter、setter转换),可以提高Vue渲染性能
       * 不可以向当前对象添加、更新、删除属性。如需修改可以将变量的引用替换掉
       */
      tableHeader: Object.freeze([
        {
          name: "用户名称",
          prop: "userIdTrans",
        },
        {
          name: "文章标题",
          prop: "docIdTrans",
        },
        {
          name: "创建时间",
          prop: "createTime",
        },
        // {
        //   name: "操作",
        //   prop: "operation",
        //   operation: [
        //     { name: "删除", clickFun: this.delCollection, show: true },
        //   ],
        // },
      ]),
      //筛选时文本框所需参数
      inputArr: [
        {
          name: "textUserIdTrans",
          defaultText: "请输入用户名称",
        },
      ],
      //搜索参数
      searchParams: {
        timeOptions: "",
        textUserIdTrans: "",
      },
    };
  },
  created() {
    this.getInitData();
  },
  methods: {
    getInitData(isSearch) {
      let timeOptions = this.searchParams.timeOptions; //日期参数
      let params = {
        data: {
          userIdTrans: this.searchParams.textUserIdTrans,
        },
        startTime: timeOptions ? timeOptions[0] : "",
        endTime: timeOptions ? timeOptions[1] : "",
        current: isSearch ? 1 : this.pageParams.currentPage,
        size: this.pageParams.pageSize,
      };
      collectionList(params).then((e) => {
        this.loading = false;
        let { code, data, msg } = e.data;
        if (code == 200) {
          this.tableData = data.records;
          this.pageParams.total = data.total;
          if (isSearch) this.pageParams.currentPage = 1;
        }
      });
    },
    //搜索事件
    searchEvent() {
      this.getInitData(true);
    },
    //删除事件
    delCollection(item) {
      this.$confirm("删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delCollection(item.id).then((e) => {
          let { code, data, msg } = e.data;
          if (code == 200) {
            this.getInitData();
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        });
      });
    },
    //批量删除
    allDel() {
      let data = this.selectedData;
      if (data.length == 0) {
        this.$message.warning("请选择要操作的数据！");
        return;
      }
      this.$confirm("删除所选数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let delIds = [];
        delIds = data.map((e) => e.id);
        allDelCollection({
          ids: delIds,
        }).then((e) => {
          let { code, data, msg } = e.data;
          if (code == 200) {
            this.getInitData();
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        });
      });
    },
    //批量导出
    allExport() {
      let timeOptions = this.searchParams.timeOptions; //日期参数
      let data = {
        data: {
          role: this.searchParams.textRole,
          roleName: this.searchParams.textRoleName,
        },
        startTime: timeOptions ? timeOptions[0] : "",
        endTime: timeOptions ? timeOptions[1] : "",
        current: this.pageParams.currentPage,
        size: this.pageParams.pageSize,
      };
      let exportParams = {
        method: "post",
        url: "/api/app/sys/role/export/list",
        data,
      };
      _exportMethods(exportParams);
    },
    //导入模板
    allImportTemplate() {
      let importParams = {
        method: "get",
        url: "/api/app/sys/role/export/template",
      };
      _exportMethods(importParams);
    },
    //详情函数式组件关闭弹框
    closeDialog() {
      this.isDialogDetailShow = false;
    },
    //在子组件上监听点击事件，如果不加.native的话，Vue会以为是自定义的事件，这样的话必须得在子组件发送一个emit事件触发才可以
    testNative() {
      // console.log("native click");
    },
    //在父组件里监听到子组件的生命周期 @hook:mounted="doSomething"
    doSomeThing() {
      // console.log('父组件监听到 mounted 钩子函数 ...');
    },
  },
};
</script>

<style scoped>
</style>

 
 